<template>
  <div class="inter-wrapper">
    <HeaderInter />
    <div class="inter-content container-fluid">
      <div class="main pb-5">
        <div class="order-area">
          <ul class="box-group">
            <li
              v-for="lang in langs"
              :key="lang.lang_code"
              class="box-items"
              :class="(lang.lang_code == currentLangCode) ? 'box-items-active' : ''"
              @click="toLang(lang.lang_code)"
            >
              {{ lang.lang_name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderInter from '@/components/HeaderInter'
import { getLangcode, defaultLangcode } from '@/utils/tool'
export default {
  name: 'Language',
  components: {
    HeaderInter
  },
  data() {
    return {}
  },
  computed: {
    langs() {
      // compatible with no support langs server //
      return this.$store.getters.shopInfo.langs ? this.$store.getters.shopInfo.langs : []
    },
    currentLangCode() {
      return getLangcode()
    }
  },
  methods: {
    toLang(lang_code) {
      // no change, not redirect //
      if (lang_code === this.currentLangCode) {
        return
      }
      this.$store.commit('SET_LANG_PATH', lang_code === defaultLangcode() ? '' : lang_code)
      window.location.href = lang_code === defaultLangcode() ? '/index' : ('/' + lang_code + '/index')
    }
  }
}
</script>

<style scoped lang="scss">
@import "assets/scss/common.scss";
.box-group {
  margin: 0 auto 1.5rem;
  padding: 15px 1.5rem;
  border-radius: 10px;
  box-shadow: 0px 8px 30px 0px rgba($main-color, $alpha: 0.15);
  .box-items {
    display: flex;
    align-items: center;
    font-size: 1rem;
    line-height: 35px;
    margin-bottom: 1rem;
    padding: 0.5rem 0 0 1rem;
    border-bottom: 1px solid rgba($main-color, $alpha: 0.15);
    color: var(--main-color);
  }
  .box-items:hover {
    cursor: pointer;
  }
  .box-items-active {
      background-color: var(--main-color);
      color: white;
  }
  .box-items-active:hover {
      cursor: default;
  }
}
</style>
